import { AlertCircle } from 'lucide-react';

/** Modal-form error banner (red alert box shown inside a modal form, above the
 * footer actions). Extracted verbatim from DistributionListsPage / MailerSetupPage,
 * where this exact markup sat inside an `{formError && (...)}` guard. Distinct from
 * <PageErrorBanner/> (page-level, px-4 py-3): this keeps the modal-banner classes
 * (`px-3 py-2`, `text-red-800`, `<span>`) so rendered output is identical. Callers
 * keep their own `{formError && (...)}` guard and pass the message in. */
export function ModalFormErrorBanner({ message }: { message: string }) {
  return (
    <div className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-800 px-3 py-2 rounded-lg text-sm">
      <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
}
